import {
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useMediaQuery,
} from '@chakra-ui/react';

import './CustomStepperStandalone.scss';
import { breakpoints } from '@/app/providers/ChakraThemeProvider';

interface CustomStepperStandaloneProps {
  steps: { title: string }[];
  activeStep: number;
  goBackToSelectedStep: (index: number) => void;
}

const CustomStepperStandalone = ({
  steps,
  activeStep,
  goBackToSelectedStep,
}: CustomStepperStandaloneProps) => {
  const [isDesktopView] = useMediaQuery([`(min-width: ${breakpoints.lg})`]);
  const orientation = isDesktopView ? 'horizontal' : 'vertical';

  const totalSteps = steps.length;
  const currentStep = activeStep + 1;

  // Hide stepper on Success page
  if (currentStep > totalSteps) return null;

  return (
    <Stepper
      size="lg"
      index={activeStep}
      className={'custom-stepper-standalone-container'}
      orientation={orientation}
    >
      {steps.map((step, index) => {
        const hasNotCompletedLastStep = activeStep < steps.length;
        const stepIsBeforeCurrent = index < activeStep;
        const stepIsBeforeCurrentAndHasNotCompletedLastStep =
          stepIsBeforeCurrent && hasNotCompletedLastStep;

        return (
          <Step key={step.title} className={`step-container`}>
            <StepIndicator
              className={`step-indicator-container ${stepIsBeforeCurrentAndHasNotCompletedLastStep ? 'clickable' : ''}`}
              onClick={
                stepIsBeforeCurrentAndHasNotCompletedLastStep
                  ? () => goBackToSelectedStep(index)
                  : undefined
              }
            >
              <StepStatus
                complete={<StepIcon className={'step-icon'} />}
                incomplete={<StepNumber className={'step-number'} />}
                active={<StepNumber className={'step-number'} />}
              />
            </StepIndicator>

            <StepTitle className={'step-title'}>{step.title}</StepTitle>

            <StepSeparator className={'stepper-separator'} />
          </Step>
        );
      })}
    </Stepper>
  );
};

export default CustomStepperStandalone;
